import { useMap } from "react-leaflet";
import { useParams } from "react-router";
import { RegularGridOnMap } from "../on-map/RegularGridOnMap";

interface Props {
  opacity: number;
  pane: string;
}
export function RegularGridOverlayer(props: Props) {
  const map = useMap();
  const { caseId = ""} = useParams<{ caseId: string }>();

  if (!map) {
    console.warn("Can't render RegularGrid overlayer when not inside <MapContainer />");
    return null;
  }

  if (!caseId) {
    console.warn("Can't render RegularGrid without a caseId");
    return null;
  }

  return render();

  function render() {
    return <RegularGridOnMap map={map} caseId={caseId} opacity={props.opacity} pane={props.pane} />;
  }
}
